import { compose } from 'recompose';
import withE2EProp from '../../withE2EProp';
import centeredQuestion from '../hoc/centeredQuestion';
import LongTextQuestion from '../LongTextQuestion';

export default compose(
  withE2EProp('respondent-custom-long-text'),
  centeredQuestion,
)(LongTextQuestion);
